import { appQueryClient } from '@libs/data-access/queries'

export const contractQueryKeys = {
  contract: (queryParams = {}) => ['contract', queryParams],

  contracts: () => ['contracts']
}

export const contractInvalidation = {
  invalidateContract: (userContractId: number) => {
    appQueryClient.invalidateQueries({
      queryKey: contractQueryKeys.contract({
        pathParams: { user_contract_id: userContractId }
      })
    })
  }
}
